/* This is generated code, don't alter */
var IfcTankTypeEnum;
(function (IfcTankTypeEnum) {
    IfcTankTypeEnum[IfcTankTypeEnum["BASIN"] = 0] = "BASIN";
    IfcTankTypeEnum[IfcTankTypeEnum["BREAKPRESSURE"] = 1] = "BREAKPRESSURE";
    IfcTankTypeEnum[IfcTankTypeEnum["EXPANSION"] = 2] = "EXPANSION";
    IfcTankTypeEnum[IfcTankTypeEnum["FEEDANDEXPANSION"] = 3] = "FEEDANDEXPANSION";
    IfcTankTypeEnum[IfcTankTypeEnum["PRESSUREVESSEL"] = 4] = "PRESSUREVESSEL";
    IfcTankTypeEnum[IfcTankTypeEnum["STORAGE"] = 5] = "STORAGE";
    IfcTankTypeEnum[IfcTankTypeEnum["VESSEL"] = 6] = "VESSEL";
    IfcTankTypeEnum[IfcTankTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcTankTypeEnum[IfcTankTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcTankTypeEnum || (IfcTankTypeEnum = {}));
const IfcTankTypeEnumCount = 9;
export { IfcTankTypeEnum, IfcTankTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcTankTypeEnum = new Int32Array([2, -6, 12]);
let prefixSumAddressIfcTankTypeEnum = new Uint32Array([0, 18, 33, 40, 51, 67, 79, 87, 96, 109]);
let slotMapIfcTankTypeEnum = new Int32Array([3, 1, 0, 2, 4, 8, 6, 5, 7]);
let encodedDataIfcTankTypeEnum = (new TextEncoder()).encode(".FEEDANDEXPANSION..BREAKPRESSURE..BASIN..EXPANSION..PRESSUREVESSEL..NOTDEFINED..VESSEL..STORAGE..USERDEFINED.");
let IfcTankTypeEnumSearch = new MinimalPerfectHash(gMapIfcTankTypeEnum, prefixSumAddressIfcTankTypeEnum, slotMapIfcTankTypeEnum, encodedDataIfcTankTypeEnum);
export { IfcTankTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcTankTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcTankTypeEnumSearch, input, cursor, endCursor);
}
